module.exports = __webpack_public_path__ + "static/media/invoiceInactive.3f210fd5.svg";